<!--
 * @Description: 下载软件介绍模块
 * @Author: F-Stone
 * @LastEditTime: 2023-10-30 17:39:20
-->

<template>
    <div :class="$style['download-module']">
        <div class="m-container">
            <div :class="$style['container-inner']">
                <div :class="$style['module-head']" class="flex justify-center">
                    <div :class="$style['module-info']">
                        <h2 :class="$style['module-title']" class="enter-animate animate__fadeInUp">
                            <span class="text">
                                <!-- A secure and easy-to-use exchange -->
                                {{$t('300248')}}
                            </span>
                        </h2>
                        <h3 :class="$style['module-subtitle']" class="enter-animate animate__fadeInUp">
                            <span class="text">
                                <!-- Download the SuperEX mobile app to keep an eye on the markets
                and make trades at the perfect moment, wherever you are. -->
                                {{$t('300249')}}
                            </span>
                        </h3>
                    </div>
                </div>
                <div :class="$style['module-data']">
                    <div :class="$style['app-market-list']" class="enter-animate animate__fadeInUp">
                        <!-- <div v-for="(item, index) in appMarketList" :key="index" :class="$style['item-wrapper']" class="relative">
                            <template v-if="item.qrcode">
                                <div :class="$style['list-item']">
                                    <div :class="$style['list-item--inner']" class="flex justify-center items-center">
                                        <svg-icon :icon-class="item.icon" :class="$style['icon']" />
                                    </div>
                                </div>
                                <div :class="$style['qrcode-box']">
                                    <img :src="item.qrcode" alt="" />
                                </div>
                            </template>
                            <a v-else :class="$style['list-item']" target="_blank" :href="item.link">
                                <div :class="$style['list-item--inner']" class="flex justify-center items-center">
                                    <svg-icon :icon-class="item.icon" :class="$style['icon']" />
                                </div>
                            </a>
                        </div> -->
                        <div :class="$style['item-wrapper']" class="relative">
                            <div :class="$style['list-item']">
                                <div :class="$style['list-item--inner']" class="flex justify-center items-center" @click="goLink(downloadUrl.appStore)">
                                    <svg-icon :icon-class="appMarketList[0].icon" :class="$style['icon']" />
                                </div>
                            </div>
                            <!-- <div :class="$style['qrcode-box']">
                                <img :src="appMarketList[0].qrcode" alt="" />
                            </div> -->
                        </div>
                        <div :class="$style['item-wrapper']">
                            <a :class="$style['list-item']" target="_blank" :href="appMarketList[1].link">
                                <div :class="$style['list-item--inner']" class="flex justify-center items-center" @click="goLink(downloadUrl.TFLink)">
                                    <svg-icon :icon-class="appMarketList[1].icon" :class="$style['icon']" />
                                </div>
                            </a>
                        </div>
                        <div :class="$style['item-wrapper']">
                            <div :class="$style['list-item']">
                                <div :class="$style['list-item--inner']" class="flex justify-center items-center" @click="goLink(downloadUrl.googlePlay)">
                                    <svg-icon :icon-class="appMarketList[2].icon" :class="$style['icon']" />
                                </div>
                            </div>
                        </div>
                        <div :class="$style['item-wrapper']">
                            <a :class="$style['list-item']" target="_blank" :href="appMarketList[3].link">
                                <div :class="$style['list-item--inner']" class="flex justify-center items-center" @click="goLink(downloadUrl.androidApk)">
                                    <svg-icon :icon-class="appMarketList[3].icon" :class="$style['icon']" />
                                </div>
                            </a>
                        </div>
                        <div :class="$style['item-wrapper']">
                            <a :class="$style['list-item']" data-type="more">
                                <div :class="$style['list-item--inner']" class="flex justify-center items-center" @click="$router.push('/downloadMore')">
                                    <span class="text">
                                        <!-- More Download Options -->
                                        {{$t('300250')}}
                                    </span>
                                    <UeIcon :class="[$style['ic'], { mirrorRotateLevel: isDirection }]" name="long-arrow-right" />
                                </div>
                            </a>
                        </div>
                    </div>
                    <div :class="$style['app-thumb']">
                        <div :class="$style['bg-layer-2']">
                            <div ref="orbContainer" :class="$style['orb-container']">
                                <canvas />
                            </div>
                        </div>
                        <div :class="$style['thumb--desktop']" class="enter-animate animate__fadeInLeft">
                            <div :class="$style['thumb--inner']">
                                <img src="../../../assets/images/newImg/app-thumb-desktop.png" alt="" />
                            </div>
                        </div>
                        <div :class="$style['thumb--mobile']" class="enter-animate animate__fadeInRight">
                            <div :class="$style['thumb--inner']">
                                <img src="../../../assets/images/newImg/app-thumb-mobile.png" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
                <div :class="$style['module-footer']">
                    <div :class="$style['app-intro']" class="enter-animate animate__fadeInUp">
                        <span class="text">
                            <!-- Every trade you make will help us advance human exploration of
              Mars and Space！ -->
                            {{$t('400002')}}
                        </span>
                    </div>
                    <div :class="$style['btn-box']" class="flex justify-center items-center relative">
                        <div :class="$style['box-bg']"></div>
                        <button v-if="!token" :class="$style['btn--register']" class="flex justify-center items-center enter-animate animate__fadeInUp" @click="$router.push('/register')">
                            <span class="text">
                                <!-- Register Now -->
                                {{$t('300352')}}
                            </span>
                            <UeIcon :class="$style['ic']" name="long-arrow-right" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { appMarketList } from '../../../data/download'
import { mapGetters } from 'vuex'
// import SvgIcon from "@/compontents/SvgIcon.vue";
// import SvgIcon from "../../svgIcon1.vue";
// import AppleStore from "../../../assets/images/newImg/svg/app-store.svg?vue-component";
// import TestFlight from "@superex/public/assets/svg/test-flight.svg?vue-component";
// import GooglePlay from "@superex/public/assets/svg/google-play.svg?vue-component";
// import AndroidApk from "@superex/public/assets/svg/android-apk.svg?vue-component";
import { createOrbEffect } from '../../../utils/orb-effect'

import { versionsApi } from '@/api/resource'

// defineOptions({
//     components: { AppleStore, TestFlight, GooglePlay, AndroidApk },
// });
export default {
    // let orbCtrl: null | ReturnType<typeof createObrCircle> = null;
    components: {
        // AppleStore,
        // SvgIcon
        // iconComponent: SvgIcon
    },
    data() {
        return {
            orbCtrl: this.null,
            appMarketList: appMarketList,
            downloadUrl: {
                appStore: '',
                googlePlay: '',
                androidApk: '',
                TFLink: '',
            },
        }
    },
    created() {
        this.getVersionsApi()
    },
    computed: {
        ...mapGetters(['isDirection', 'language','token']),
    },
    methods: {
        goLink(url) {
            if (!url) {
                return false
            } else {
                window.open(url)
            }
        },
        createObrCircle() {
            const orbContainer = this.$refs.orbContainer
            const canvas = orbContainer && orbContainer.querySelector('canvas')
            console.log(`canvas`, canvas)
            if (!canvas) return
            const width = orbContainer.offsetWidth || 0
            const height = orbContainer.offsetHeight || 0
            const ctrl = new createOrbEffect({
                container: canvas,
                colorChoices: ['#ef9200', '#ef9200', '#ef9200', '#FF5C00'],
                originPointer: {
                    x: width * 0.5,
                    y: height * 0.5,
                },
                blurOption: {
                    blur: 35,
                    quality: 15,
                },
                getSize() {
                    const width = orbContainer.offsetWidth || 0
                    const height = orbContainer.offsetHeight || 0
                    return { width, height }
                },
                setBounds() {
                    const width = orbContainer.offsetWidth || 0
                    const height = orbContainer.offsetHeight || 0
                    return {
                        originX: width * 0.5,
                        originY: height * 0.5,
                        x: { min: -100, max: 100 },
                        y: { min: -10, max: 50 },
                    }
                },

                onResize() {
                    const width = orbContainer.offsetWidth || 0
                    const height = orbContainer.offsetHeight || 0
                    ctrl.updatePos(width * 0.5, height * 0.5, { duration: 0 })
                },
                orbParam: {
                    radius: window.innerWidth / 3,
                    scaleRange: [0.8, 1],
                },
            })
            return ctrl
        },
        getVersionsApi() {
            versionsApi().then((res) => {
                // this.downloadUrl.appStore = 'https://testflight.apple.com/join/nPtPpKJr'
                this.downloadUrl.TFLink = res.data.find((v) => v.client == '2')
                    ? res.data.find((v) => v.client == '2').extraLink
                    : ''
                this.downloadUrl.appStore = res.data.find(
                    (v) => v.client == '2'
                )
                    ? res.data.find((v) => v.client == '2').link
                    : ''
                this.downloadUrl.googlePlay = res.data.find(
                    (v) => v.client == '3'
                )
                    ? res.data.find((v) => v.client == '3').link
                    : ''
                this.downloadUrl.androidApk = res.data.find(
                    (v) => v.client == '3'
                )
                    ? res.data.find((v) => v.client == '3').extraLink
                    : ''
            })
        },
    },

    mounted() {
        this.orbCtrl = this.createObrCircle()
        this.orbCtrl && this.orbCtrl.init()
        this.orbCtrl && this.orbCtrl.start()
    },

    beforeDestroy() {
        this.orbCtrl && this.orbCtrl.destroy()
    },
}
</script>
<style lang="scss" module>
@import '../../../assets/uemo-scss/scss/abstracts/_mixins.scss';
@import '../../../assets/uemo-scss/scss/abstracts/_functions.scss';
.download-module {
    position: relative;
    z-index: 10;

    padding: 177px 0 150px;
}
.module-head {
    position: relative;
    z-index: var(--g--z-index);

    margin-bottom: 50px;
}
.module-info {
    text-align: center;
    .module-title {
        font-size: 58px;
        font-weight: 700;
        line-height: 110%;
        color: #fff;
        max-width: 600px;
        margin: 0 auto;

        text-align: center;
        letter-spacing: -2.56px;
    }
    .module-subtitle {
        font-size: 24px;
        line-height: 140%;

        max-width: 662px;
        margin: 0 auto;
        margin-top: 20px;

        text-align: center;

        color: color(var(--g--color-font--default), 0.6);
    }
}
.module-data {
    position: relative;
    .bg-layer-2 {
        position: absolute;
        z-index: 0;
        top: 50%;
        left: 50%;

        overflow: hidden;

        width: 100vw;
        height: 100vh;

        transform: translate(-50%, -43%);
        pointer-events: none;
        &::before {
            @include ab-cover;
            z-index: calc(var(--g--z-index) * 2);

            content: '';
            pointer-events: none;

            background-image: linear-gradient(
                to bottom,
                color(var(--g--color-bg--default), 1),
                color(var(--g--color-bg--default), 0.95) 10%,
                color(var(--g--color-bg--default), 0.9) 15%,
                color(var(--g--color-bg--default), 0) 30%
            );
        }
        .orb-container {
            @include move-center;
            z-index: var(--g--z-index);

            width: 100vw;
            height: 100vh;
        }
        canvas {
            position: absolute;
            bottom: 0;
            left: 0;

            width: 100%;
        }
    }
    .app-market-list {
        position: relative;
        z-index: calc(var(--g--z-index) * 10);

        display: flex;

        width: 100%;
        margin: 0 auto;
        margin-bottom: 80px;

        align-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;
        gap: 12px;
        justify-content: center;
        .item-wrapper {
            &:hover {
                .qrcode-box {
                    top: calc(100% + 8px);

                    visibility: visible;

                    opacity: 1;
                }
            }
        }
        .qrcode-box {
            @include image-placeholder-v4(145, 166);
            position: absolute;
            z-index: calc(var(--g--z-index) * 2);
            top: calc(100% + 14px);
            left: 50%;

            visibility: hidden;
            overflow: hidden;

            transition: 0.26s ease;
            transform: translateX(-50%);

            opacity: 0;
            border-radius: 6px;
            background-color: #fff;
            box-shadow: 0 4px 8px 0 rgb(0, 0, 0 / 0.08);
        }
        .list-item {
            position: relative;

            display: block;
            overflow: hidden;

            min-width: 124px;
            padding: 1px;

            border-radius: 7px;
            background-image: linear-gradient(
                rgba(#46484f, 0.7),
                rgba(#46484f, 0.1)
            );
            svg {
                height: 32px;
            }
            &:hover {
                &::after {
                    opacity: 1;
                }
            }
            &::after {
                @include ab-cover;
                z-index: 0;

                content: '';
                transition: 0.36s;

                opacity: 0;
                background-image: conic-gradient(
                    from var(--deg, 130deg) at 60% 40%,
                    rgba(#885e31, 0.4),
                    rgba(#885e31, 0.4),
                    rgba(#885e31, 0.4),
                    rgba(#ffa73d, 0.5),
                    rgba(#ffdaae, 0.8),
                    rgba(#ffdaae, 0.8),
                    rgba(#ffa73d, 0.6),
                    rgba(#ffa73d, 0.5),
                    rgba(#885e31, 0.5),
                    rgba(#885e31, 0.4)
                );
            }
            &[data-type='more'] {
                font-size: 20px;
                font-weight: 700;
                line-height: 160%;

                white-space: nowrap;
                .list-item--inner {
                    display: grid;
                    color: #fff;
                    gap: 10px;
                    grid-auto-flow: column dense;
                }
                .ic {
                    font-size: em(18px, 16px);
                }
            }
        }
        .list-item--inner {
            position: relative;
            z-index: var(--g--z-index);

            width: 100%;
            height: 100%;
            padding: 19px 24px;

            border-radius: 6px;
            background-color: color(var(--g--color-bg--default));
        }
    }
    .app-thumb {
        position: relative;

        margin: 0 auto;
        &::after {
            display: block;
            clear: both;

            content: '';
        }
        .thumb--desktop {
            font-size: 614px;

            position: relative;
            z-index: calc(var(--g--z-index) * 2);

            float: right;

            max-width: 1em;
            padding: 6px;

            border-radius: em(31px, 1036px);
            background-image: conic-gradient(
                from var(--deg, 230deg) at 60% 40%,
                rgba(#885e31, 0.4),
                rgba(#885e31, 0.4),
                rgba(#ffa73d, 0.7),
                rgba(#ffa73d, 0.8),
                rgba(#ffdaae, 0.8),
                rgba(#ffdaae, 0.8),
                rgba(#ffa73d, 0.6),
                rgba(#885e31, 0.5),
                rgba(#885e31, 0.4),
                rgba(#885e31, 0.4)
            );
            .thumb--inner {
                overflow: hidden;

                // opacity: 0;
                border-radius: em(25px, 1036px);
                background-color: #181818;
            }
        }
        .thumb--mobile {
            font-size: 614px;

            position: absolute;
            z-index: calc(var(--g--z-index) * 3);
            top: em(42px, 1036px);
            // left: em(-115px, 1036px);
            left: em(10px, 1080px);

            overflow: hidden;

            max-width: em(296px, 1036px);
            padding: 3px;

            // transform: translateX(80px);

            border-radius: em(50px, 1036px);
            background-image: conic-gradient(
                from var(--deg, 160deg) at 60% 40%,
                rgba(#885e31, 0.4),
                rgba(#885e31, 0.4),
                rgba(#ffa73d, 1),
                #ffa73d,
                #ffdaae,
                #ffdaae,
                #ffa73d,
                rgba(#ffa73d, 1),
                rgba(#885e31, 0.5),
                rgba(#885e31, 0.4),
                rgba(#885e31, 0.4)
            );
            .thumb--inner {
                padding: 2px;

                border-radius: em(48px, 1036px);
                background-color: #181818;
            }
        }
    }
}
.module-footer {
    position: relative;
    z-index: var(--g--z-index);

    margin-top: 90px;
    .app-intro {
        font-size: 36px;
        font-weight: 700;
        line-height: 140%;
        color: #fff;
        max-width: 675px;
        margin: 0 auto;
        margin-bottom: 30px;

        text-align: center;
    }
    .box-bg {
        @include move-center;
        position: absolute;
        z-index: 0;

        width: 570px;
        height: 352px;
        margin: 0 auto;

        pointer-events: none;

        background-image: url('../../../assets/images/newImg/app-btn-bg.png');
        background-position: center center;
        background-size: contain;
    }
    .btn--register {
        font-size: 24px;

        position: relative;
        z-index: var(--g--z-index);

        padding: 20px 46px;

        transition: 0.26s ease;
        color: #fff;
        // border: 2px solid color(var(--g--color-theme--main));
        border: 2px solid #FFC72B;
        border-radius: 100px;
        .ic {
            margin-left: 10px;

            transition: 0.26s ease;
        }
        &:hover {
            color: color(var(--g--color-font--default), 1);
            // border-color: color(var(--g--color-theme--main));
            // background-color: color(var(--g--color-theme--main));
            border-color: #FFC72B;
            background-color: #FFC72B;
            .ic {
                transform: translateX(6px);
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/compontents/newHome/index/DownloadModule.vue